import ZipInput from "../shared/ZipCodeInput.component";

function GetRecommendations() {
  return (
    <div
      className="grid-x align-center text-center margin-0"
      style={{ paddingTop: 56, paddingBottom: 40 }}
    >
      <h3 className="h3 cell text-uppercase text-center">explore our plans</h3>
      <div
        className="cell large-text small-12 medium-8"
        style={{ paddingTop: 21, paddingBottom: 21 }}
      >
        Can't decide? Answer a few questions, and we'll recommend plans based on
        your needs.
      </div>
      <div
        className="cell large-text"
        style={{ fontWeight: 700, paddingBottom: 21 }}
      >
        Enter your ZIP Code to get started.
      </div>
      <div className="cell small-12 medium-7 large-5">
        <ZipInput />
      </div>
    </div>
  );
}

export default GetRecommendations;
